/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { Typography } from '@mui/material';
import {
  ActivityContactPersonViewModel,
  ContactPersonViewModel,
  OfferGroupListItemViewModel,
  OfferTypeCodeListDto,
  SocialProviderUnitDto,
  SocialProviderUnitLookupDto,
} from '../../../api-service/clients';
import { KeyValuePair } from '../../../models';

export const formatOptionsByName = (option: any) => option.name ?? '';
export const renderOptionsByName = (props: object, option: { id: string; name?: string }) => (
  <li {...props} key={option.id}>
    {formatOptionsByName(option)}
  </li>
);

export const renderOfferTypeOptions = (props: object, option: OfferTypeCodeListDto) => (
  <li {...props} key={option.id} title={option.description}>
    <div>
      <div>{option.name}</div>
      {option.description && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', whiteSpace: 'normal' }}
        >
          {option.description}
        </Typography>
      )}
    </div>
  </li>
);

export const renderKeyValuePair = (props: object, option: any) => (
  <li {...props} key={option.id}>
    {formatKeyValuePairOptions(option)}
  </li>
);

export const formatKeyValuePairOptions = (option: KeyValuePair) => option.value ?? '';
export const renderKeyValuePairOptions = (props: object, option: KeyValuePair) => (
  <li {...props} key={option.key}>
    {formatKeyValuePairOptions(option)}
  </li>
);

export const formatCompanyContactPersonOptions = (option: ContactPersonViewModel) => {
  if (option && option.companyContactPersonId) {
    return `${option.fullName} ${option.email ? `(${option.email})` : ''}`;
  }
  return '';
};
export const renderCompanyContactPersonOptions = (props: object, option: ContactPersonViewModel) => (
  <li {...props} key={option.companyContactPersonId}>
    {formatCompanyContactPersonOptions(option)}
  </li>
);

export const renderContactPersonOptions = (props: object, option: ActivityContactPersonViewModel) => (
  <li {...props} key={option.companyContactPersonId}>
    {option.givenName} {option.surname}
  </li>
);

export const renderOfferGroupsOptions = (props: object, option: OfferGroupListItemViewModel) => (
  <li {...props} key={option.offerGroupId}>
    {option.name} {option.offerGroupIdentifier ? `(${option.offerGroupIdentifier})` : ''}
  </li>
);
export const formatOfferGroupsOptions = (option: OfferGroupListItemViewModel) => {
  if (option) {
    return `${option.name ? option.name : ''} ${option.offerGroupIdentifier ? `(${option.offerGroupIdentifier})` : ''}`;
  }
  return '';
};

export const formatSocialProviderUnitByName = (spu: SocialProviderUnitLookupDto | SocialProviderUnitDto) => `${spu.name} - ${spu.externalId}`;

export const renderSocialProviderUnitOptions = (props: object, option: SocialProviderUnitLookupDto | SocialProviderUnitDto) => (
  <li {...props} key={option.id}>
    {formatSocialProviderUnitByName(option)}
  </li>
);
